const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-grid">
        <div className="footer-brand">
          <img src="/logo-tram.png" alt="Tram Energie Plomberie" style={{ height: 70 }} />
          <p>
            Artisan qualifié en plomberie, chauffage, climatisation et énergies renouvelables.
            Intervenant en Loiret depuis plus de 15 ans.
          </p>
          <div className="footer-certif">RGE — QualiPAC</div>
        </div>

        <div className="footer-col">
          <h4>Services</h4>
          <ul>
            <li><a href="#services">Plomberie</a></li>
            <li><a href="#services">Chauffage</a></li>
            <li><a href="#services">Climatisation</a></li>
            <li><a href="#services">Salles de bain</a></li>
            <li><a href="#services">Pompes à chaleur</a></li>
          </ul>
        </div>

        <div className="footer-col">
          <h4>Navigation</h4>
          <ul>
            <li><a href="#accueil">Accueil</a></li>
            <li><a href="#realisations">Réalisations</a></li>
            <li><a href="#rge">Certification RGE</a></li>
            <li><a href="#contact">Contact</a></li>
          </ul>
        </div>

        <div className="footer-col">
          <h4>Informations</h4>
          <ul>
            <li><a href="#contact">Devis gratuit</a></li>
            <li><a href="mailto:contact@tramenergie.com">contact@tramenergie.com</a></li>
            <li><span style={{ color: 'var(--color-text-muted)', fontSize: '0.9rem' }}>Loiret</span></li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <span>© {year} Tram Energie Plomberie — Tous droits réservés</span>
        <span>Artisan RGE — SIRET : 880 532 296 00014</span>
      </div>
    </footer>
  );
};

export default Footer;
